import { Maybe, just } from 'maybeasy';
import { observer } from 'mobx-react';
import InlineRichText from '../components/InlineRichText';
import { TPlainTextKey, TranslationsContext, translation } from '../../../../../../Translations';

interface Props {
  description: string;
  onDescriptionChange: (value: string) => void;
  emptyStateText: Maybe<TPlainTextKey>;
  placeholder: Maybe<TPlainTextKey>;
  intercomTarget: Maybe<string>;
}

function Description({
  description,
  onDescriptionChange,
  emptyStateText,
  placeholder,
  intercomTarget,
}: Props) {
  return (
    <TranslationsContext.Consumer>
      {(ts) => (
        <InlineRichText
          value={description}
          onChange={onDescriptionChange}
          emptyStateText={emptyStateText}
          placeholder={placeholder.map((p) => translation(p)(ts))}
          editAriaLabel={just(translation('Edit description')(ts))}
          backgroundColor={just('var(--card)')}
          intercomTarget={intercomTarget}
        />
      )}
    </TranslationsContext.Consumer>
  );
}

export default observer(Description);
